export enum MapProviderApiUrls {
    GetMapProvider = "/api/MapProvider/GetMapProviders"
}